module.exports = __webpack_public_path__ + "static/media/service_body_05.8a11f689.webp";